var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDynamicPromotions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3994_53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.90464 21.0781C9.35312 21.0781 14.4667 20.649 19.2448 18.6045C23.8972 16.6133 27.1289 12.9314 29.132 9.92705L32.0669 11.2955L30.381 0.265625L20.8478 6.06416L23.3828 7.24618C19.2129 13.8458 12.1799 18.1953 4.34961 18.9586L4.44312 21.063C4.84292 21.0663 5.3439 21.0781 5.90464 21.0781ZM25.8058 7.30728L26.3727 6.31285L25.3115 5.81806L28.7739 3.71206L29.3863 7.71833L28.343 7.23191L27.849 8.02475C26.0643 10.8884 22.9788 14.7119 18.4149 16.6653C17.319 17.1342 16.2015 17.5118 15.0906 17.8147C19.5116 15.4008 23.2507 11.7901 25.8058 7.30728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 35.7344H10.6172V29.4062H0V35.7344ZM2.10938 31.5156H8.50781V33.625H2.10938V31.5156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7266 35.7344H23.2734C23.2734 34.2032 23.2734 26.5603 23.2734 25.1875H12.7266V35.7344ZM21.1641 33.625H14.8359V31.5156H21.1641V33.625ZM14.8359 27.2969H21.1641V29.4062H14.8359V27.2969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3828 20.9688V35.7344H36C36 32.8461 36 24.0801 36 20.9688H25.3828ZM33.8906 33.625H27.4922V31.5156H33.8906V33.625ZM33.8906 29.4062H27.4922V27.2969H33.8906V29.4062ZM27.4922 25.1875V23.0781H33.8906V25.1875H27.4922Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3994_53"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamicPromotions);
export default __webpack_public_path__ + "static/media/dynamic-promotions.4089065f4d8c7ca292ac8699e88b55fc.svg";
export { ForwardRef as ReactComponent };